<template>
    <nav class="nav-menu">
      <router-link v-for="link in links" :to="link.route" :key="link.name">
        + {{link.name}}
      </router-link>
    </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      links: [
        {
          name: 'Accueil',
          route: '/',
        },
        {
          name: 'Présentation',
          route: '/presentation',
        },
        {
          name: 'Réalisations & Références',
          route: '/realisations',
        },
        {
          name: 'Contact',
          route: '/contact',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .nav-menu {
    padding-top: 1em;
    justify-content: space-evenly;
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      height: 75%;
      margin: auto;
      padding: 0 25% 0 33%;
      a {
        width: 100%;
        white-space: pre-line;
      }
    }
    @media (max-width: 575.98px) {
      padding: 0 15% 0 25%;
      a {
        font-size: 0.75em !important;
      }
    }
    @media (max-width: 768px) {
      font-size: 1.75em !important;
    }
    a {
      font-family: "Robotoo";
      font-size: $font-size-small;
      font-weight: $font-weight-medium;
      color: $color-black;
      margin-bottom: 12px;
      text-transform: uppercase;
      text-align: left;
    &.router-link-exact-active {
       color: $color-yellow;
     }
    }
  }
</style>
